import { MimeType } from '../../../common/media/mimeConstants';
import getFilenameFromUrl from '../../../common/files/getFilenameFromUrl';

const WEBP_FILE_EXTENSION = 'webp';

/**
 * Infer MIME type from the image URL filename when the blob type is unavailable.
 */
export const getMimeTypeFromImageUrl = (imageUrl: string | null, fallbackMimeType: string): string => {
    if (!imageUrl) return fallbackMimeType;

    const filename = getFilenameFromUrl(imageUrl, fallbackMimeType).toLowerCase();
    if (filename.endsWith(`.${WEBP_FILE_EXTENSION}`)) return MimeType.WEBP;
    if (filename.endsWith('.png')) return MimeType.PNG;

    return fallbackMimeType;
};
